import type { AuiRendererProps } from '../registry';

export function AuiCard({ node, children }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const title = props.title as string | undefined;
  const description = props.description as string | undefined;

  return (
    <div data-testid="aui-card" className="border-t border-border pt-5 pb-2">
      {(title || description) && (
        <div className="mb-4">
          {title && (
            <h4 className="text-sm font-semibold text-foreground">{title}</h4>
          )}
          {description && (
            <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
          )}
        </div>
      )}
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
